import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "course-group-list-empty",
  templateUrl: "./course-group-list-empty.component.html",
  styleUrls: ["./course-group-list-empty.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseGroupListEmptyComponent {}
